import { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

export default function useSimplePortal(content, selector) {
    const container = useRef();
    useEffect(() => {
        container.current = document.querySelector(selector);
    }, [selector])

    if (container.current) {
        return ReactDOM.createPortal(content, container.current);
    }

    return null;
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/PaymentCancellation/useSimplePortal.js